import React, { HTMLAttributes } from 'react'

import BasketShoppingIcon from '@/common/components/icons/BasketShoppingIcon'
import HospitalIcon from '@/common/components/icons/HospitalIcon'
import PlaneIcon from '@/common/components/icons/PlaneIcon'
import ShopIcon from '@/common/components/icons/ShopIcon'
import TrainIcon from '@/common/components/icons/TrainIcon'

import { Border, Background } from './styled'

const CONFIG = {
  hospital: { icon: HospitalIcon, color: '#da1d24' },
  convenienceStore: { icon: ShopIcon, color: '#ffc541' },
  supermarket: { icon: BasketShoppingIcon, color: '#23aec8' },
  transportation: { icon: TrainIcon, color: '#302e7c' },
  airport: { icon: PlaneIcon, color: '#50a943' },
}

interface NearbyPlaceSymbolProps extends HTMLAttributes<HTMLDivElement> {
  type: string
  selected?: boolean
}

const NearbyPlaceSymbol = ({
  type,
  selected,
  ...props
}: NearbyPlaceSymbolProps) => {
  const { icon: Icon, color = '#7b7b7b' } = CONFIG[type] || {}

  return (
    <Border {...props} $color={color} $selected={selected}>
      <Background $color={color}>
        {Icon && <Icon className='text-white' size={16} />}
      </Background>
    </Border>
  )
}

export default NearbyPlaceSymbol
